/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Csv_Group_A_Start_HeaderInputs */

const en_compare_event_groups_csv_group_a_start_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_A_Start_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group A Start`)
};

const fr_compare_event_groups_csv_group_a_start_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_A_Start_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Début du groupe A`)
};

const de_compare_event_groups_csv_group_a_start_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_A_Start_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe A Start`)
};

const it_compare_event_groups_csv_group_a_start_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_A_Start_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizio del Gruppo A`)
};

const ru_compare_event_groups_csv_group_a_start_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_A_Start_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Старт группы А`)
};

const es_compare_event_groups_csv_group_a_start_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_A_Start_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio del Grupo A`)
};

const zh_cn2_compare_event_groups_csv_group_a_start_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_A_Start_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A组开始`)
};

const ja_compare_event_groups_csv_group_a_start_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_A_Start_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループAスタート`)
};

const hi_compare_event_groups_csv_group_a_start_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_A_Start_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह ए प्रारंभ`)
};

const pt_pt2_compare_event_groups_csv_group_a_start_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_A_Start_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Início do Grupo A`)
};

/**
* | output |
* | --- |
* | "Group A Start" |
*
* @param {Compare_Event_Groups_Csv_Group_A_Start_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_csv_group_a_start_header = /** @type {((inputs?: Compare_Event_Groups_Csv_Group_A_Start_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Csv_Group_A_Start_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_csv_group_a_start_header(inputs)
	if (locale === "de") return de_compare_event_groups_csv_group_a_start_header(inputs)
	if (locale === "it") return it_compare_event_groups_csv_group_a_start_header(inputs)
	if (locale === "ru") return ru_compare_event_groups_csv_group_a_start_header(inputs)
	if (locale === "es") return es_compare_event_groups_csv_group_a_start_header(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_csv_group_a_start_header(inputs)
	if (locale === "ja") return ja_compare_event_groups_csv_group_a_start_header(inputs)
	if (locale === "hi") return hi_compare_event_groups_csv_group_a_start_header(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_csv_group_a_start_header(inputs)
	return en_compare_event_groups_csv_group_a_start_header(inputs)
});